/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithRatingName
 */
export interface WithRatingNameOptional {
  /**
   *
   * @type {string}
   * @memberof WithRatingName
   */
  ratingName?: string;
}

export interface WithRatingName extends WithRatingNameOptional {
  /**
   *
   * @type {string}
   * @memberof WithRatingName
   */
  ratingName?: string;
}

export interface WithRatingNameTrackedI {
  /**
   *
   * @type {string}
   * @memberof WithRatingName
   */
  ratingName?: string;
  ratingNameIsSet: boolean;
}

transformDatesMap.set("WithRatingName", function (model: WithRatingName) {});

export type WithRatingNameMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  ratingName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var WithRatingNameMeta: WithRatingNameMetaI = {} as WithRatingNameMetaI;
WithRatingNameMeta = typeMeta("WithRatingName", {
  ratingName: propertyMeta(
    "ratingName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = WithRatingNameMeta;

registerMeta(() => {});

export class WithRatingNameTracked implements WithRatingNameTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  ratingName__I?: string = undefined;
  ratingNameIsSet: boolean = false;
  set ratingName(v: undefined | string) {
    if (v !== undefined) {
      this.ratingName__I = v;
      this.ratingNameIsSet = true;
    } else {
      this.ratingName__I = v || undefined;
      this.ratingNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingName() {
    return this.ratingName__I;
  }
  constructor(config?: WithRatingNameOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithRatingNameOptional,
    options?: AssignOptions,
  ): WithRatingNameTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.ratingName &&
      this.ratingNameApplyFilter(optionsRequired.filter)
    ) {
      this.ratingName = config.ratingName;
      if (optionsRequired.unassign) this.ratingNameIsSet = false;
      else this.ratingNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithRatingNameTrackedI {
    const cloned = {} as WithRatingNameTrackedI;
    if (
      this.ratingNameIsSetDeep() &&
      this.ratingNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingNameIsSet = true;
      cloned.ratingName = this.ratingName;
    } else {
      //cloned.ratingNameIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithRatingNameTrackedI {
    if (!this.ratingNameApplyFilter(filter)) this.ratingNameIsSet = false;

    return this;
  }
  ratingNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithRatingNameMeta.ratingName,
      WithRatingNameMeta,
      this.ratingName,
      this,
    );
  }
  ratingNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingNameIsSet && this.ratingNameApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.ratingNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
